import { Clock, Phone } from "lucide-react";

const UrgencyBar = () => (
  <div
    className="bg-brand-red text-white text-sm md:text-base py-2 px-6 flex flex-col md:flex-row items-center justify-between gap-3"
    data-testid="urgency-bar"
  >
    <div className="flex items-center gap-2" data-testid="urgency-bar-text">
      <Clock size={16} />
      <span>Urgence 24h/24 • Intervention rapide à Maisons-Alfort et Val-de-Marne</span>
    </div>
    <div className="flex items-center gap-3">
      <a
        href="mailto:contact@fast-alu.com"
        className="hidden md:flex items-center gap-2 border border-white/40 px-4 py-2 rounded-full uppercase text-xs"
        data-testid="urgency-bar-email-link"
      >
        contact@fast-alu.com
      </a>
      <a
        href="tel:0184160307"
        className="flex items-center gap-2 bg-white text-brand-red font-bold uppercase text-xs md:text-sm px-4 py-2 rounded-full"
        data-testid="urgency-bar-call-link"
      >
        <Phone size={16} />
        Appelez 01 84 16 03 07
      </a>
    </div>
  </div>
);

export default UrgencyBar;
